import { Partner } from './partner';
import { Customer } from './customer';

export interface BoxUpdateRequest {
  displayName?: string;
  customer?: Customer;
  manager?: Partner;
}

export namespace BoxUpdateRequest {
  export function mapToApiValue({ customer, manager, ...restOfData }: BoxUpdateRequest): any {
    return {
      ...restOfData,
      managerId: manager?.id,
      customerId: customer?.id,
    };
  }
}
